import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49fa323e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tradition" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "传统数据迁移方案", -1 /* HOISTED */))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "难以兼顾成本与速度", -1 /* HOISTED */))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _hoisted_3,
          (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("，")
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("br", _hoisted_4)),
          _hoisted_5
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_row, { gutter: [40,20] }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_col, {
              xs: 24,
              md: 12,
              xl: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["item", `i_${index+1}`])
                }, [
                  _createVNode(_component_a_typography_title, { level: 5 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createVNode(_component_a_typography_paragraph, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (v) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (v.t1)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(v.t1), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (v.t2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(v.t2), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ], 2 /* CLASS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}